export default {
      id: "options-2-28-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "sprite-46b249.svg#options-2-28-usage",
      toString: function () {
        return this.url;
      }
    }